import HomesWhatsNewPopUpModal from 'src/components/Settings/HomeManagement/HomesWhatsNewPopUpModal.svelte';
import { shouldShowHomesWhatsNew } from 'src/helpers/homes-onboarding-helper';
import { network } from 'src/stores/session/native-bridge';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';

export const HomesWhatsNewModalConfig = (): ModalConfig => ({
	id: 'homesWhatsNewState',
	component: HomesWhatsNewPopUpModal,
	props: {
		priority: 45,
		showModal: true,
	},
	rules: [
		{
			check: () => get(network) !== 'offline' && shouldShowHomesWhatsNew(),
			expected: true,
		},
		NoPremiumVoucherCheckRule,
	],
});
